import { Constants } from '.'

const initialState = {
  open: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case Constants.UI_MODAL_OPEN:
      return {
        ...state,
        ...action.payload,
        open: true
      }

    case Constants.UI_MODAL_CLOSE:
      return {
        ...state,
        open: false
      }

    case Constants.UI_MODAL_CLEAR_PROPS:
      return {
        open: false
      }

    default:
      return state
  }
}
